import { useEffect, useState, useRef } from "react";
import './autocomplete.css'

export default function AddressAutocomplete({ onSelect }) {
    const [input, setInput] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const abortRef = useRef(null);
    const ignoreNextFetchRef = useRef(false);


    useEffect(() => {
        if (ignoreNextFetchRef.current) {
            ignoreNextFetchRef.current = false;
            return;
        }

        if (!input || input.length < 3) {
            setSuggestions([]);
            return;
        }

        let active = true;

        async function fetchSuggestions() {
            try {
                const { AutocompleteSuggestion } =
                    await window.google.maps.importLibrary("places");

                // Cancel previous request
                abortRef.current?.abort();
                abortRef.current = new AbortController();

                const { suggestions } =
                    await AutocompleteSuggestion.fetchAutocompleteSuggestions(
                        {
                            input,
                            region: "us",
                        },
                        { signal: abortRef.current.signal }
                    );

                if (active) {
                    setSuggestions(suggestions);
                }
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Autocomplete error:", err);
                }
            }
        }

        fetchSuggestions();

        return () => {
            active = false;
        };
    }, [input]);

    async function handleSelect(suggestion) {
        ignoreNextFetchRef.current = true;

        const placeId = suggestion.placePrediction.placeId;

        const { Place } =
            await window.google.maps.importLibrary("places");

        const place = new Place({ id: placeId });

        await place.fetchFields({
            fields: ["addressComponents", "formattedAddress"],
        });

        onSelect({
            placeId,
            formattedAddress: place.formattedAddress,
            addressComponents: place.addressComponents,
        });

        setInput(place.formattedAddress);
        setSuggestions([]);
    }

    return (
        <div className="autocomplete-container">
            <input
                value={input}
                onChange={e => setInput(e.target.value)}
                placeholder="Search Address"
                autoComplete="off"
            />

            {suggestions.length > 0 && (
                <ul>
                    {suggestions.map(s => (
                        <li
                            key={s.placePrediction.placeId}
                            onClick={() => handleSelect(s)}
                            
                        >
                            {s.placePrediction.text.text}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
